const fleetItems = [
  {
    image: 'https://static.readdy.ai/image/ac89004c0dc4ecdcf411495653d0d9a7/5442858620c6da04cea2b3f68ea1de2e.jpeg',
    title: 'Dry Van Fleet',
    description: '53ft enclosed trailers with climate control capabilities'
  },
  {
    image: 'https://static.readdy.ai/image/ac89004c0dc4ecdcf411495653d0d9a7/1f5d732d77ec76aa6a60d8c631b64eab.jpeg',
    title: 'Flatbed Fleet',
    description: '48-53ft flatbeds for oversized and heavy loads'
  },
  {
    image: 'https://public.readdy.ai/ai/img_res/577ba71bba4e48c0fef44cfa051dc957.jpg',
    title: 'Cross Dock Facility',
    description: 'State-of-the-art transfer and distribution center'
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Large%20modern%20warehouse%20interior%20with%20organized%20storage%20racks%20and%20freight%20pallets%2C%20professional%20logistics%20facility%2C%20clean%20industrial%20space%20with%20good%20lighting%2C%20simple%20background%2C%20commercial%20photography&width=640&height=800&seq=fleet-warehouse&orientation=portrait',
    title: 'Warehouse Storage',
    description: 'Secure climate-controlled storage facilities'
  }
];

export default function Fleet() {
  return (
    <section id="fleet" className="py-20 px-6 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our Fleet
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Modern, Well-Maintained Equipment Ready for Your Cargo
          </p>
        </div>

        <div className="flex overflow-x-auto gap-6 pb-8 snap-x snap-mandatory scrollbar-hide">
          {fleetItems.map((item, index) => (
            <div
              key={index}
              className="flex-shrink-0 w-80 snap-start"
            >
              <div className="relative bg-gray-100 rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-shadow">
                {index === 0 && (
                  <div className="absolute top-4 left-4 z-10 bg-slate-800 text-white px-4 py-1.5 rounded-full text-xs font-semibold">
                    FEATURED
                  </div>
                )}
                <div className="w-full h-96">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
              <div className="text-center mt-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">{item.title}</h3>
                <p className="text-sm text-gray-600">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}